module.exports = __webpack_public_path__ + "img/icon-facebook.66755f52ffb77e0e827dfee1a1b29dfe.svg";